import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { ITENSPORPAGINA, MAPBOX_ACCESSTOKEN, TURISMO_HOTEL } from '../../app.config';
import { BuscaHotelRQ } from '../../model';
@Injectable()
export class HotelService {
    constructor(private http: HttpClient) { }

    buscarHotelPorId(id: number): Observable<any> {
        return this.http.get<any>(`${TURISMO_HOTEL}/api/Hotel/${id}`);
    }

    buscarHotel(busca: BuscaHotelRQ, pagina: Number): Observable<any> {
        return this.http.post<any>(`${TURISMO_HOTEL}/api/Hotel/buscaasync?Pagina=${pagina}&ItensPorPagina=${ITENSPORPAGINA}`, busca, { headers: new HttpHeaders().set('noloader', 'true') });
    }

    buscarMapaHotel(parametrosBuscaMapa): Observable<any> {
        return this.http.post<any>(`${TURISMO_HOTEL}/api/Hotel/buscaasync/mapa`, parametrosBuscaMapa, { headers: new HttpHeaders().set('noloader', 'true') });
    }

    buscarHotelEspecifico(hotelCodigoFornecedor: string, guid: string): Observable<any> {
        return this.http.get<any>(`${TURISMO_HOTEL}/api/Hotel/buscaasync/mapa/${hotelCodigoFornecedor}/${guid}`);
    }

    removerHotel(hotel: any): Observable<any> {
        return this.http.delete<any>(`${TURISMO_HOTEL}/api/Hotel/${hotel.Id}`);
    }

    buscarPolitica(hotel: any): Observable<any> {
        return this.http.patch<any>(`${TURISMO_HOTEL}/api/hotel/politica/${hotel.ReservaId}/${hotel.Id}`, {}, { headers: new HttpHeaders().set('noloader', 'true') });
    }

    buscarPoliticaListagem(hotelId: number, quartoId: number, agenciaId: number = 0, guid: string): Observable<any> {
        guid = encodeURIComponent(guid);
        return this.http.get<any>(`${TURISMO_HOTEL}/api/hotel/politicalistagem?agenciaId=${agenciaId}&hotelId=${hotelId}&guid=${guid}&quartoId=${quartoId}`, { headers: new HttpHeaders().set('noloader', 'false') });
    }

    reservarHotel(politica: any): Observable<any> {
        return this.http.post<any>(`${TURISMO_HOTEL}/api/Hotel/reservar`, politica, { headers: new HttpHeaders().set('noloader', 'true') });
    }

    cancelarHotel(hotel: any): Observable<any> {
        return this.http.patch<any>(`${TURISMO_HOTEL}/api/hotel/cancelar/${hotel.ReservaId}/${hotel.Id}`, {}, { headers: new HttpHeaders().set('noloader', 'true') });
    }

    atualizarStatusHotel(hotel: any): Observable<any> {
        return this.http.patch<any>(`${TURISMO_HOTEL}/api/hotel/atualizar/${hotel.Id}`, {}, { headers: new HttpHeaders().set('noloader', 'true') });
    }

    detalhesHotel(hotel: any): Observable<any> {
        return this.http.patch<any>(`${TURISMO_HOTEL}/api/hotel/detalhes`, hotel, { headers: new HttpHeaders().set('noloader', 'true') });
    }

    trocarHotelFornecedor(agrupador: any): Observable<any> {
        return this.http.post<any>(`${TURISMO_HOTEL}/api/hotel/trocarHotelFornecedor`, agrupador);
    }
}


@Injectable()
export class MapaService {
    constructor(
        private http: HttpClient
    ) { }

    private mapboxAccessToken = MAPBOX_ACCESSTOKEN;
    private httpHeaders = new HttpHeaders().set('noloader', 'true');
    private url = "https://api.mapbox.com";

    pesquisaLocalizacaoInicial(query: string): Observable<{ lat: number, lng: number }> {
        query = encodeURIComponent(query);

        return this.http.get<any>(
            `${this.url}/search/geocode/v6/forward?q=${query}&access_token=${this.mapboxAccessToken}&language=pt`, { headers: this.httpHeaders }
        ).pipe(
            map(res => {
                const { coordinates } = res.features[0].geometry;
                return { lat: coordinates[1], lng: coordinates[0] };
            })
        );
    }

    searchLocalizacao(query: string, longlat: string): Observable<any> {
        query = encodeURIComponent(query);
        longlat = encodeURIComponent(longlat);
        // const bbox = encodeURIComponent("-28.8361,-33.7519,-7.5378,-5.2500");
        return this.http.get<any>(
            // `${this.url}/search/geocode/v6/forward?q=${query}type=location&access_token=${this.mapboxAccessToken}&language=pt&proximity=${longlat}&limit=10`, { headers: this.httpHeaders }
            `${this.url}/search/searchbox/v1/suggest?q=${query}type=locality&access_token=${this.mapboxAccessToken}&language=pt&proximity=${longlat}&limit=10`, { headers: this.httpHeaders }
        );
    }
}